import React from 'react';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import EventObjectMoveActions from 'flux/actions/EventObjectMoveActions';
import { DropTarget } from 'react-dnd';
import classNames from 'classnames';
import Popover from 'shared/components/misc/popover';
import PopoverActions from 'shared/flux/actions/PopoverActions';

/**
 * Event Folder Breadcrumb
 *
 */
export default React.createClass({
  mixins: [PureRenderMixin],

  displayName: 'EventFolderBreadcrumb',

  render() {
    let breadCrumbState = this.props.breadCrumb;

    return (
      <span className="event-folder-breadcrumbs">
        {this._getBreadcrumbNodes(breadCrumbState)}
      </span>
    );
  },

  _getBreadcrumbNodes(fullPath) {
    let { teamId, eventId, onRootClick } = this.props;

    if (!fullPath)
      return (
        <DroppableRootLink
          teamId={teamId}
          eventId={eventId}
          onClick={onRootClick}
        />
      );

    const delimiter = ',';

    let parts = fullPath.split(delimiter);

    let breadNodes = parts.map((part, i) => {
      let lastOne = i === parts.length - 1;
      let separatorNode = null;

      let folderIcon = 'folder-open';
      let className = 'breadcrumb-no-link';
      if (!lastOne) {
        className = undefined;
        folderIcon = undefined;
        separatorNode = <Icon name="angle-right" />;
      }

      let innerNode = (
        <BreadcrumbNoLink
          className={className}
          text={part}
          separatorNode={separatorNode}
          folderIcon={folderIcon}
        />
      );

      if (lastOne) return innerNode;

      let parentPath = parts.slice(0, i).join(delimiter);

      return (
        <DroppableBreadcrumbLink
          parentPath={parentPath}
          onClick={this.props.onBreadcrumbClick}
          part={part}
        >
          {innerNode}
        </DroppableBreadcrumbLink>
      );
    });

    const breadTruncationThreshold = 4;

    if (breadNodes.length > breadTruncationThreshold) {
      let truncatedItems = breadNodes.splice(
        0,
        breadNodes.length - breadTruncationThreshold,
      );

      breadNodes = [
        <TruncatedItemsPopover truncatedItems={truncatedItems} />,
        <span>
          &nbsp;
          <Icon name="angle-right" />
          &nbsp;
        </span>,
      ].concat(breadNodes);
    }

    breadNodes.unshift(
      <DroppableRootLink
        teamId={teamId}
        eventId={eventId}
        onClick={onRootClick}
        separator
      />,
    );

    return breadNodes;
  },
});

function dropCollect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
    itemType: monitor.getItemType(),
  };
}

const dropTargetFactory = (actionCallback) => {
  return {
    /* eslint-disable no-unused-vars */
    canDrop(props, monitor) {
      return true;
    },

    drop(props, monitor, component) {
      if (monitor.didDrop()) {
        return;
      }
      let { parentPath, part } = props;
      let monitorItem = monitor.getItem();
      let objectToMoveId = monitorItem.item.get('_id');

      let objectIdsToMove = [objectToMoveId];

      if (monitorItem.selectedItemIds && monitorItem.selectedItemIds.size) {
        objectIdsToMove = monitorItem.selectedItemIds.toArray();
      }

      actionCallback(objectIdsToMove, parentPath, part);
    },
    /* eslint-enable no-unused-vars */
  };
};

const breadcrumbTarget = dropTargetFactory(
  (objectIdsToMove, parentPath, part) => {
    EventObjectMoveActions.moveToPath(objectIdsToMove, parentPath, part);
  },
);

const rootLinkTarget = dropTargetFactory((objectIdsToMove) => {
  EventObjectMoveActions.move(objectIdsToMove);
});

const RootLink = React.createClass({
  render() {
    let { connectDropTarget, isOver, onClick, separator } = this.props;

    let className = classNames({
      'event-folder-breadcrumb-can-drop': isOver,
    });

    let separatorNode = null;
    if (separator) {
      separatorNode = <Icon name="angle-right" />;
    }

    return connectDropTarget(
      <span className={className}>
        <a className="breadcrumb-link" onClick={onClick}>
          <Icon name="calendar" />
          &nbsp;Event Dash&nbsp;&nbsp;
        </a>
        {separatorNode} &nbsp;
      </span>,
    );
  },
});

const DroppableRootLink = DropTarget(
  'FSObject',
  rootLinkTarget,
  dropCollect,
)(RootLink);

// eslint-disable-next-line react/prop-types
const BreadcrumbNoLink = ({ folderIcon, text, separatorNode, className }) => {
  let iconNode = null;
  if (folderIcon)
    iconNode = (
      <span>
        <Icon name={folderIcon} />
        &nbsp;
      </span>
    );
  return (
    <span className={className}>
      {iconNode}
      {text} {separatorNode} &nbsp;
    </span>
  );
};

const BreadcrumbLink = ({
  children,
  parentPath,
  part,
  isOver,
  connectDropTarget,
  onClick,
}) => {
  let className = classNames('breadcrumb-link', {
    'event-folder-breadcrumb-can-drop': isOver,
  });

  return connectDropTarget(
    <a className={className} onClick={() => onClick(parentPath, part)}>
      {children}
    </a>,
  );
};

const DroppableBreadcrumbLink = DropTarget(
  'FSObject',
  breadcrumbTarget,
  dropCollect,
)(BreadcrumbLink);

const TRUNCATE_POPOVER_ID = 'truncated-breadcrumb-items';

const TruncatedItemsDisplayNode = React.createClass({
  componentWillReceiveProps(nextProps) {
    if (nextProps.isOver && !this.props.isOver) {
      PopoverActions.show(TRUNCATE_POPOVER_ID);
    }
  },

  render() {
    let { connectDropTarget } = this.props;

    return connectDropTarget(<span>...&nbsp;</span>);
  },
});

const truncateDisplayNodeTarget = {
  /* eslint-disable no-unused-vars */
  canDrop: function (props, monitor) {
    return false;
  },
  drop: function (props, monitor, component) {},
  /* eslint-enable no-unused-vars */
};

function truncateCollect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
  };
}

const HoverableTruncatedItemsDisplayNode = DropTarget(
  'FSObject',
  truncateDisplayNodeTarget,
  truncateCollect,
)(TruncatedItemsDisplayNode);

/* eslint-disable react/prop-types */
const TruncatedItemsPopover = ({ truncatedItems }) => {
  let displayNode = <HoverableTruncatedItemsDisplayNode />;

  let listItems = truncatedItems.map((item) => {
    return <div>{item}</div>;
  });

  return (
    <div className="event-folder-breadcrumb-truncate-popover">
      <Popover
        showMouseOnEnter
        popoverId={TRUNCATE_POPOVER_ID}
        displayNode={displayNode}
      >
        {listItems}
      </Popover>
    </div>
  );
};
/* eslint-enable react/prop-types */
